<tec-modal
    [isVisible]="true"
    [title]="'PROCESSES.MENU.BLOCK_IDENTITY' | translate"
    [buttonPrimaryLabel]="(isStepOne ? 'BUTTON.CONTINUE' : 'BUTTON.BLOCK') | translate"
    [buttonSecondaryLabel]="'BUTTON.CANCEL' | translate"
    [buttonPrimaryStyle]="!isStepOne"
    (closeEvent)="closeModal($event)"
>
    <ng-container body [formGroup]="form">
        @if (errorMsg) {
            <tec-alert status="error" [msg]="errorMsg" (closeAlert)="errorMsg = ''" />
        } @if (isStepOne) {
            <div class="body__text">
                <span>{{ 'PROCESSES.BLOCK_IDENTITY_MODAL.SELECT_PARAMETERS' | translate }}</span>
            </div>
            <form [formGroup]="blockParameters" class="block-parameters-form">
                @if (showOcrBlockOption) {
                    <tec-card-select
                        formGroupName="ocr"
                        [tagImg]="{ icon: 'icon-card' }"
                        [title]="'PROCESSES.BLOCK_IDENTITY_MODAL.OCR_TITLE' | translate"
                        [tags]="
                            blockedIdentityParams.includes('ocr')
                                ? [{ label: 'PROCESSES.BLOCK_IDENTITY_MODAL.BLOCKED' | translate, status: 'error' }]
                                : [{ label: 'PROCESSES.BLOCK_IDENTITY_MODAL.ACTIVE' | translate, status: 'success' }]
                        "
                        [disabled]="form.get('blockParameters.ocr')?.disabled"
                        [selected]="form.get('blockParameters.ocr')?.value"
                        (selectedChange)="form.get('blockParameters.ocr').patchValue($event)"
                    />
                }
                @if (showIpBlockOption) {
                    <tec-card-select
                        formGroupName="ip"
                        [tagImg]="{ icon: 'icon-map-pin' }"
                        [title]="'PROCESSES.BLOCK_IDENTITY_MODAL.IP_TITLE' | translate"
                        [tags]="
                            blockedIdentityParams.includes('ip')
                                ? [{ label: 'PROCESSES.BLOCK_IDENTITY_MODAL.BLOCKED' | translate, status: 'error' }]
                                : [{ label: 'PROCESSES.BLOCK_IDENTITY_MODAL.ACTIVE' | translate, status: 'success' }]
                        "
                        [disabled]="form.get('blockParameters.ip')?.disabled"
                        [selected]="form.get('blockParameters.ip')?.value"
                        (selectedChange)="form.get('blockParameters.ip').patchValue($event)"
                    />
                }
                @if (showFaceBlockOption) {
                    <tec-card-select
                        formGroupName="face"
                        [tagImg]="{ icon: 'icon-user' }"
                        [title]="'PROCESSES.BLOCK_IDENTITY_MODAL.FACE_TITLE' | translate"
                        [tags]="
                            blockedIdentityParams.includes('face')
                                ? [{ label: 'PROCESSES.BLOCK_IDENTITY_MODAL.BLOCKED' | translate, status: 'error' }]
                                : [{ label: 'PROCESSES.BLOCK_IDENTITY_MODAL.ACTIVE' | translate, status: 'success' }]
                        "
                        [disabled]="form.get('blockParameters.face')?.disabled"
                        [selected]="form.get('blockParameters.face')?.value"
                        (selectedChange)="form.get('blockParameters.face').patchValue($event)"
                    />
                }
            </form>
        } @else {
            @if (form.invalid && form.touched) {
                <tec-alert [msg]="'PROCESSES.BLOCK_IDENTITY_MODAL.AT_LEAST_ONE_REASON' | translate" hiddenCloseButton />
            }
            <tec-tile [subtitle]="'PROCESSES.BLOCK_IDENTITY_MODAL.SELECT_REASONS' | translate">
                <tec-checkbox-group formControlName="reasons" [options]="checkboxOptions" [multiple]="true" />
                @if (showOtherReason) {
                    <tec-textarea
                        formControlName="otherReason"
                        [placeholder]="'PROCESSES.BLOCK_IDENTITY_MODAL.WRITE_REASON' | translate"
                        [hasError]="otherReasonControl.touched && otherReasonControl?.invalid"
                        [maxlength]="300"
                    />
                }
            </tec-tile>
        }
    </ng-container>
</tec-modal>
